import React, { JSX } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import LzXBaseField from "../BaseField";

import "./TextareaField.scss";

export interface LzPTextareaField {
    fluid?: boolean,
    required?: boolean,
    placeholder?: string,
    label?: string,
    name?: string,
    icon?: JSX.Element,
    id?: string,
    className?: string,
    style?: React.CSSProperties,
    value?: string,
    minRows?: number,
    onChange?: (name: string, value: string) => void
}

const LzXTextareaField = (props: LzPTextareaField) => {

    if (typeof props.value === 'undefined') {
        return <CircularProgress />;
    }

    const theName = props.name || '';
    const theId = props.id || 'id_' + theName;

    const handleOnChange = (val: string): void => {
        if (props.onChange) {
            props.onChange(theName, val);
        }
    };

    return (
        <LzXBaseField
            id={theId}
            fluid={props.fluid}
            required={props.required}
            icon={props.icon}
            name={props.name}
            label={props.label}
        >

            <TextField multiline
                fullWidth={props.fluid}
                required={props.required}
                placeholder={props.placeholder || ''}
                name={props.name || ''}
                className={'lz-textarea ' + (props.className ? props.className : '')}
                style={props.style || {}}
                value={props.value}
                onChange={(evt) => handleOnChange(evt.target.value)}
                minRows={props.minRows}
            />

        </LzXBaseField>
    );
};

export default LzXTextareaField;
